import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from '../ui/SlideWrapper';
import { Code2, Factory, Rocket } from 'lucide-react';
const pillars = [{
  icon: Code2,
  title: 'Individuelle Software',
  desc: 'Software- & IT-Unternehmen mit Fokus auf maßgeschneiderte Lösungen statt Standardware.'
}, {
  icon: Factory,
  title: 'Industrie-Expertise',
  desc: 'Starke Nähe zu industriellen Prozessen, Produktionsumgebungen und Maschinenanbindung.'
}, {
  icon: Rocket,
  title: 'End-to-End Partner',
  desc: 'Ganzheitliche Begleitung von der ersten Idee bis zum produktiven Einsatz und Betrieb.'
}];
export function AboutSlide() {
  return <SlideWrapper data-id="element-117">
      <div className="h-full flex flex-col justify-center" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-119">
          <h2 className="text-5xl font-bold text-primary mb-4" data-id="element-120">Wer wir sind</h2>
          <div className="h-1 w-24 bg-accent rounded-full" data-id="element-121" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-122">
          {pillars.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2 + index * 0.15,
          duration: 0.6
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow duration-300 group" data-id="element-123">
              <div className="w-16 h-16 bg-primary/5 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300" data-id="element-124">
                <item.icon className="w-8 h-8 text-primary group-hover:text-accent transition-colors duration-300" data-id="element-125" />
              </div>
              <h3 className="text-xl font-bold text-primary mb-3" data-id="element-126">
                {item.title}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-127">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </SlideWrapper>;
}